<template>
<div style="width: 100%; height: 100%;">
  <div id="tomHornGameClient">
    <div class="error-message" v-if="errorStatus">
      <h3>{{ errorStatus }}</h3>
      <div>Try reloading game or return to casino lobby</div>
    </div>
  </div>
</div>
</template>

<script>
import { getTomHornParams } from '../../../helper/api/fetchParams'
import shrotToLongISOLang from '../../../helper/convertLangCodeToLongISO'

export default {
  name: 'TomHornView',
  data: () => ({ errorStatus: '' }),
  async mounted() {
    const appWrapper = document.querySelector('.app-wrapper');
    appWrapper.classList.add('overflow-hidden');
    document.body.classList.add('tom-horn-open');
    const { providerGameId, gameId, playerId, popSessionId, languageCode, clientPlatform, iOs, exitUrl } = this.$route.query;

    try {
      const providerData = await getTomHornParams({ providerGameId, gameId, playerId, popSessionId, lang: languageCode, clientPlatform, iOs });

      const providerParams = {};
      providerData.forEach(it => { providerParams[it.key] = it.value });
      providerParams['var:lang'] = shrotToLongISOLang(languageCode);
      providerParams['var:exitUrl'] = exitUrl;
      providerParams.height = '100%';
      providerParams.width = '100%';

      const baseURL = providerParams['param:base'];
      const providerScript = document.createElement('script');
      providerScript.setAttribute('src', `${baseURL}ClientUtils.js`);
      document.head.appendChild(providerScript);
      // eslint-disable-next-line
      providerScript.onload = function() { renderClient(providerParams, 'tomHornGameClient', 'iframe') };

      window.addEventListener('message', this.handleEvent);
    } catch(err) {
      this.errorStatus = err
    }
  },
  methods: {
    handleEvent(e) { e.data && (e.data.wpgaction == 'close.parent' || e.data.wpgaction == 'close') && this.onExitGamePlatform(); },
    onExitGamePlatform() { window.top.location.href = this.$route.query.exitUrl; }
  }
}
</script>

<style lang="scss">
  .tom-horn-open {
    overflow: hidden;
  }

  #tomHornGameClient {
    width: 100%;
    height: 100%;
  }

  .overflow-hidden {
    overflow: hidden;
  }

  .error-message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
  }
</style>